import { DataPage } from "@xbs/muon";
import { getCellIds } from "../helpers/main";
import { IAction, IActionConfig } from "../types";
import { getStringWidth } from "@dhx/ts-common/core";
import { getFormattedValue } from "../helpers/format";

export class FitColumn implements IAction {
	public config: IActionConfig;
	private _page: DataPage;
	private _prev: { width: number }[];

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page;
	}

	do() {
		const { cell, spreadsheet, grid } = this.config;
		const { col } = getCellIds(cell as string, grid);
		const sizes = this._page.getSize();
		const range = this._page.getRange(0, col, sizes[0], col);
		let newWidth = 40;
		range.forEach((val, index) => {
			if (val) {
				const meta = this._page.getCell(index, col);
				const width = getStringWidth(getFormattedValue(`${val}`, meta.format));
				if (width > newWidth) {
					newWidth = width;
				}
			}
		});
		const { cols } = this._page.getMeta();
		this._prev = [...cols];
		newWidth += 20;
		const colsBefore = cols.slice(0, col);
		const colsAfter = cols.slice(col + 1);
		
		this._page.setMeta({cols: [...colsBefore, {width: newWidth}, ...colsAfter]});
		(spreadsheet as any)._updateGridState();
	}

	undo() {
		const { spreadsheet } = this.config;
		this._page.setMeta({cols: this._prev});
		(spreadsheet as any)._updateGridState();
	}
}
